export const DATA_TABLE = {
  FILTER_DELAY: 500,
  DATE_ONLY_FORMAT: 'MM/DD/YYYY',
  PAGE_SIZE: 20
}

export const DATE_ONLY_API_FORMAT = 'YYYY-MM-DD'
